import { Box } from '@mui/material';
import { ImageOutlined as ImageOutlinedIcon } from '@mui/icons-material';
import { platformIconData } from '../lib/social';

function PortfolioThumbnail({ item, height = 180, showPlatformIcon = true }) {
  return (
    <Box sx={{ position: 'relative' }}>
      {item.thumbnailUrl ? (
        <Box
          component="img"
          src={item.thumbnailUrl}
          alt={`${item.title} thumbnail`}
          sx={{ width: '100%', height, objectFit: 'cover', display: 'block' }}
        />
      ) : (
        <Box sx={{ width: '100%', height, bgcolor: 'grey.200', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <ImageOutlinedIcon sx={{ color: 'grey.400', fontSize: 32 }} />
        </Box>
      )}
      {showPlatformIcon && item.platform && (
        <Box
          component="img"
          src={platformIconData(item.platform)}
          alt={item.platform}
          sx={{
            position: 'absolute',
            top: 10,
            right: 10,
            width: 28,
            height: 28,
            borderRadius: '8px',
            boxShadow: '0 1px 4px rgba(20, 10, 50, 0.35)',
          }}
        />
      )}
    </Box>
  );
}

export default PortfolioThumbnail;
